$(function () {
    // Function to check if nodes exists in DOM
    $.fn.exists = function () {
        return this.length !== 0;
    }

    // Team Card assign ids for modals
    $.each($("a[data-target='#cardModal']"), function (i, val) {
        $(val).attr("data-target", $(this).attr("data-target") + i);
    });
    $.each($("div.cardModal"), function (i, val) {
        $(val).attr("id", "cardModal" + i);
    });

    // Carousels assign ids for indicators
    $.each($(".carouselCaptions"), function (i, val) {
        $(val).removeClass("carouselCaptions").addClass("carouselCaptions" + i);
        $(val).find("[data-target='.carouselCaptions']").attr("data-target", ".carouselCaptions" + i);
    });
    // Box Images with hover assign ids for modals
    // Team Card assign ids for modals
    $.each($("a[data-target='#boxModal']"), function (i, val) {
        $(val).attr("data-target", $(this).attr("data-target") + i);
    });
    $.each($("div.boxModal"), function (i, val) {
        $(val).attr("id", "boxModal" + i);
    });

    // Load More Button for news
    (function () {
        var newCount = 5;

        $("#newsloadmore").click(function () {
            var button = $(this);
            button.attr('disabled', 'disabled');

            $.get('/umbraco/surface/blog/getNews?startIndex=' + newCount)
                .then(res => {
                    var html = $(res.html);

                    $(document).ready(function () {
                        $('.restofnews').append(html);
                        newCount += 3;
                        button.removeAttr('disabled');

                        if (!res.articlesRemaining)
                            button.remove();
                    });
                });
        });
    })();

    // Load More Button for events
    (function () {
        var newCount = 3;

        $("#eventsloadmore").click(function () {
            var button = $(this);
            button.attr('disabled', 'disabled');

            $.get('/umbraco/surface/blog/getEvents?startIndex=' + newCount)
                .then(res => {
                    var html = $(res.html);

                    $(document).ready(function () {
                        $('.upcomingeventslist').append(html);
                        newCount += 3;
                        button.removeAttr('disabled');

                        if (!res.articlesRemaining)
                            button.remove();
                    });
                });
        });
    })();

    // Load More Button for articles
    (function () {
        var newCount = 3;

        $("#articlesloadmore").click(function () {
            var button = $(this);
            button.attr('disabled', 'disabled');

            $.get('/umbraco/surface/blog/getArticles?startIndex=' + newCount)
                .then(res => {
                    var html = $(res.html);

                    $(document).ready(function () {
                        $('.restofarticles').append(html);
                        newCount += 3;
                        button.removeAttr('disabled');

                        if (!res.articlesRemaining)
                            button.remove();
                    });
                });
        });
    })();

    // Blog social share button
    $(".blogsharebutton").click(function (evt) {
        evt.preventDefault();
        $(".socialbuttons").toggleClass("d-flex");
    });

});

$(window).on("load", function () {
    try {
        $('.like-button')
            .tooltip({
                placement: 'left',
                trigger: 'manual',
                template: `<div class="tooltip tooltip-orange" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`
            })
            .tooltip('show')
            .click(function () {
                var button = $(this);
                var id = button.data('id');

                button.attr('disabled', 'disabled');

                $.get('/umbraco/api/pagelike/toggleLike?nodeId=' + id)
                    .then(function (count) {
                        button
                            .removeAttr('disabled')
                            .toggleClass('liked')
                            .attr('data-original-title', count)
                            .tooltip('show');
                    });
            });
    }
    catch (err) {
        /* document.getElementById("demo").innerHTML = err.message;*/
    }
    
});

$(document).ready(function () {
    try {
        $('.staffcardgroup').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        });
    }
    catch (err) {
       /* document.getElementById("demo").innerHTML = err.message;*/
    }

});

$('#user_reply').bind('focus', function () {
    $('#user_name').removeClass('d-none');
    $('#user_email').removeClass('d-none');
});

$('#post_comment').bind('focus', function () {
    $('#user_name').removeClass('d-none');
    $('#user_email').removeClass('d-none');
});

$('.year-filter').on('change', function () {
    var url = $(this).children(":selected").data("url");
    window.location.href = url;
});

// Function for the accessibility

const header = document.querySelector('header');
const headerFocusableElements = header.querySelectorAll('input, button, a, textarea, select');

headerFocusableElements.forEach(element => {
    element.setAttribute('tabindex', '0');
});

var menuToggle = document.querySelector('.header-nav-toggle');
var navList = document.querySelector('.nav-content-list li a');

menuToggle.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === "Tab" ) {
        e.preventDefault();
        menuToggle.click();
        navList.focus();
    }
});
document.addEventListener('keyup', function (e) {
    if (e.which == 9) {
        if (!document.querySelector('.header-nav').contains(document.activeElement)) {
            document.querySelector('body').classList.remove('open-menu');
        }
    }
});